export default __webpack_public_path__ + "static/media/11.52330d97.jpg";